module.exports = __webpack_public_path__ + "img/ProfileMission.97d84a45.jpg";